/* eslint-disable no-param-reassign */
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Button } from "antd";
import CustomLayout from "../../General/CustomLayout/CustomLayout";
import BuildTargetsDrawer from "../../BuildTargets/BuildTargetsDrawer";
import ReportBuilderResultContent from "./ReportBuilderResultContent";
import useReportBuilder from "../../../hooks/ReportBuilder/useReportBuilder";
import QuickReportsModal from "../../Modal/QuickReportsModal";
import FreeFormModal from "../../Modal/FreeFormModal";
import AddBehavioralSegmentModal from "../../Modal/AddBehavioralSegmentModal";
import WhitespacesSelectionModal from "../../Modal/WhitespacesSelectionModal";
import SaveAnalysisModal from "../../Modal/SaveAnalysisModal";
import PublishDashboardModal from "../../Modal/PublishDashboardModal";
import AddAudienceModal from "../../Modal/AddAudienceModal";
import InsightsDetailsModal from "../../Modal/InsightsDetailsModal";
import ReportBuilderResultHeader from "./ReportBuilderResultHeader";
import useShowInsights from "../../../hooks/useShowInsights";
import LoadAnalysis from "../../General/LoadAnalysis";
import NoSubCompareResultModal from "../../ReportBuilder/NoSubscription/NoSubCompareResultModal";
import { fDownloadReportCSV, isDisplayTreeMap } from "../../../utils/oneintelligence/OneIntelligenceHelper";
import NoSubMOKBModal from "../NoSubscription/NoSubMOKBModal";
import { isViewer } from "../../../utils/MainHelper";

function ReportBuilderResult() {
    const [showLoadReport, setShowLoadReport] = useState(false);
    const [showSaveAnalysis, setShowSaveAnalysis] = useState(false);
    const [showPublishAnalysis, setShowPublishAnalysis] = useState(false);
    const [showQuickReport, setshowQuickReport] = useState(false);
    const [showFreeForm, setShowFreeForm] = useState(false);
    const [showAddBehaviouralSegment, setShowAddBehaviouralSegment] = useState(false);
    const [showWhitespacesSelection, setShowWhitespacesSelection] = useState({
        show: false,
        isInclude: true,
        analysis: ""
    });
    const { displayMode } = useSelector((state) => state.treemapreports);
    const { visibleAddAudienceModal, visibleInsightsModal, visibleMOKBModalSub } = useSelector((state) => state.reports);
    const { behaviouralSegmentData, setBehaviouralSegmentData } = useReportBuilder();
    const { hasInsightPermission } = useShowInsights()

    const newTreeMap = isDisplayTreeMap()
    const isViewerVal = isViewer()
    return (
        <CustomLayout
            className="reportBuilder-content_container"
            style={{ width: "100%", height: "100%" }}
            header={isViewerVal ? <div className="d-flex justify-content-between" style={{ width: "100%", padding: "2mm 4mm" }}>
                <div className="d-flex gap-1 justify-content-end" style={{ width: "100%" }}>
                    <Button
                        style={{
                            borderColor: "#2563eb",
                            color: "#2563eb"
                        }}
                        onClick={() => {
                            fDownloadReportCSV()
                        }}
                    >
                        Download CSV
                    </Button>
                </div>
            </div> : (
                <ReportBuilderResultHeader
                    setBehaviouralSegmentData={setBehaviouralSegmentData}
                    setShowWhitespacesSelection={setShowWhitespacesSelection}
                    setShowAddBehaviouralSegment={setShowAddBehaviouralSegment}
                    setShowFreeForm={setShowFreeForm}
                    setshowQuickReport={setshowQuickReport}
                    setShowPublishAnalysis={setShowPublishAnalysis}
                    setShowSaveAnalysis={setShowSaveAnalysis}
                    setShowLoadReport={setShowLoadReport}
                />
            )}
            classNameBody={`reportBuilder-content_body ${newTreeMap ? displayMode : ""}`}
        >
            <ReportBuilderResultContent
                setBehaviouralSegmentData={setBehaviouralSegmentData}
                setShowWhitespacesSelection={setShowWhitespacesSelection}
                setShowAddBehaviouralSegment={setShowAddBehaviouralSegment}
                setShowFreeForm={setShowFreeForm}
                setshowQuickReport={setshowQuickReport}
            />

            {isViewerVal ? "" : <>
                {showQuickReport && <QuickReportsModal visible={showQuickReport} onClose={setshowQuickReport} />}
                {showFreeForm && <FreeFormModal visible={showFreeForm} onClose={setShowFreeForm} />}
                {showAddBehaviouralSegment && (
                    <AddBehavioralSegmentModal
                        visible={showAddBehaviouralSegment}
                        onClose={setShowAddBehaviouralSegment}
                        data={behaviouralSegmentData}
                    />
                )}
                {showWhitespacesSelection.show && (
                    <WhitespacesSelectionModal
                        visible={showWhitespacesSelection}
                        onClose={setShowWhitespacesSelection}
                    />
                )}
                <BuildTargetsDrawer />
                {showLoadReport && <LoadAnalysis visible={showLoadReport} onClose={setShowLoadReport} />}
                {showSaveAnalysis && <SaveAnalysisModal visible={showSaveAnalysis} onClose={setShowSaveAnalysis} />}
                {showPublishAnalysis && <PublishDashboardModal visible={showPublishAnalysis} onClose={setShowPublishAnalysis} />}
                {visibleAddAudienceModal.visible && <AddAudienceModal visible={visibleAddAudienceModal.visible} />}
                {(visibleInsightsModal.visible && hasInsightPermission) && <InsightsDetailsModal data={visibleInsightsModal} />}
                {(visibleInsightsModal.visible && !hasInsightPermission) && <NoSubCompareResultModal data={visibleInsightsModal} />}
                {(visibleMOKBModalSub.visible) && <NoSubMOKBModal />}
            </>}
        </CustomLayout>
    );
}
export default ReportBuilderResult;
